/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ annualPrice: NonNullable<unknown> }} Annual_Promo_SuffixInputs */

const en_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/month. <span>${i?.annualPrice} /year</span>`)
};

const id_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ bulan. <span>${i?.annualPrice} / tahun</span>`)
};

const ms_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/bulan <span>${i?.annualPrice} /tahun</span>`)
};

const ca_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mes. <span>${i?.annualPrice} /any</span>`)
};

const cs_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/měsíc. <span>${i?.annualPrice} /rok</span>`)
};

const da_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/måned. <span>${i?.annualPrice} /år</span>`)
};

const de_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/Monat. <span>${i?.annualPrice} /Jahr</span>`)
};

const et_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/kuus. <span>${i?.annualPrice} /aasta</span>`)
};

const es_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mes. <span>${i?.annualPrice} /año</span>`)
};

const fr_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mois. <span>${i?.annualPrice} /année</span>`)
};

const hr_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mjesec. <span>${i?.annualPrice} /godina</span>`)
};

const it_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mese. <span>${i?.annualPrice} /anno</span>`)
};

const lv_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mēnesī <span>${i?.annualPrice} /gadā</span>`)
};

const lt_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mėn. <span>${i?.annualPrice} /metai</span>`)
};

const hu_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/hónap. <span>${i?.annualPrice} /év</span>`)
};

const nl_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/maand. <span>${i?.annualPrice} /jaar</span>`)
};

const nb_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/måned. <span>${i?.annualPrice} /år</span>`)
};

const pl_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/miesiąc. <span>${i?.annualPrice} /rok</span>`)
};

const pt_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mês. <span>${i?.annualPrice} /ano</span>`)
};

const ro_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/lună. <span>${i?.annualPrice} /an</span>`)
};

const sk_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mesiac. <span>${i?.annualPrice} /rok</span>`)
};

const sl_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/mesec. <span>${i?.annualPrice} /leto</span>`)
};

const fi_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/kk. <span>${i?.annualPrice} /vuosi</span>`)
};

const sv_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/månad. <span>${i?.annualPrice} /år</span>`)
};

const vi_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/tháng. <span>${i?.annualPrice} /năm</span>`)
};

const tr_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ay. <span>${i?.annualPrice} /yıl</span>`)
};

const el_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/μήνα. <span>${i?.annualPrice} /έτος</span>`)
};

const bg_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/месец. <span>${i?.annualPrice} /година</span>`)
};

const ru_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/месяц. <span>${i?.annualPrice} /год</span>`)
};

const sr_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/месец. <span>${i?.annualPrice} /година</span>`)
};

const uk_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/місяць. <span>${i?.annualPrice} /рік</span>`)
};

const ka_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/თვეში. <span>${i?.annualPrice} /წელიწადში</span>`)
};

const hi_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/महीना. <span>${i?.annualPrice} /वर्ष</span>`)
};

const th_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/เดือน.<span>${i?.annualPrice} /ปี</span>`)
};

const ko_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/월 <span>${i?.annualPrice} /년</span>`)
};

const zh_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/月 <span>${i?.annualPrice} /年</span>`)
};

const zh_tw_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/月。 <span>${i?.annualPrice} /年</span>`)
};

const ja_annual_promo_suffix = /** @type {(inputs: Annual_Promo_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/月 <span>${i?.annualPrice} /年</span>`)
};

/**
* | output |
* | --- |
* | "/month. <span>{annualPrice} /year</span>" |
*
* @param {Annual_Promo_SuffixInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_promo_suffix = /** @type {((inputs: Annual_Promo_SuffixInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_Promo_SuffixInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_promo_suffix(inputs)
	if (locale === "ms") return ms_annual_promo_suffix(inputs)
	if (locale === "ca") return ca_annual_promo_suffix(inputs)
	if (locale === "cs") return cs_annual_promo_suffix(inputs)
	if (locale === "da") return da_annual_promo_suffix(inputs)
	if (locale === "de") return de_annual_promo_suffix(inputs)
	if (locale === "et") return et_annual_promo_suffix(inputs)
	if (locale === "es") return es_annual_promo_suffix(inputs)
	if (locale === "fr") return fr_annual_promo_suffix(inputs)
	if (locale === "hr") return hr_annual_promo_suffix(inputs)
	if (locale === "it") return it_annual_promo_suffix(inputs)
	if (locale === "lv") return lv_annual_promo_suffix(inputs)
	if (locale === "lt") return lt_annual_promo_suffix(inputs)
	if (locale === "hu") return hu_annual_promo_suffix(inputs)
	if (locale === "nl") return nl_annual_promo_suffix(inputs)
	if (locale === "nb") return nb_annual_promo_suffix(inputs)
	if (locale === "pl") return pl_annual_promo_suffix(inputs)
	if (locale === "pt") return pt_annual_promo_suffix(inputs)
	if (locale === "ro") return ro_annual_promo_suffix(inputs)
	if (locale === "sk") return sk_annual_promo_suffix(inputs)
	if (locale === "sl") return sl_annual_promo_suffix(inputs)
	if (locale === "fi") return fi_annual_promo_suffix(inputs)
	if (locale === "sv") return sv_annual_promo_suffix(inputs)
	if (locale === "vi") return vi_annual_promo_suffix(inputs)
	if (locale === "tr") return tr_annual_promo_suffix(inputs)
	if (locale === "el") return el_annual_promo_suffix(inputs)
	if (locale === "bg") return bg_annual_promo_suffix(inputs)
	if (locale === "ru") return ru_annual_promo_suffix(inputs)
	if (locale === "sr") return sr_annual_promo_suffix(inputs)
	if (locale === "uk") return uk_annual_promo_suffix(inputs)
	if (locale === "ka") return ka_annual_promo_suffix(inputs)
	if (locale === "hi") return hi_annual_promo_suffix(inputs)
	if (locale === "th") return th_annual_promo_suffix(inputs)
	if (locale === "ko") return ko_annual_promo_suffix(inputs)
	if (locale === "zh") return zh_annual_promo_suffix(inputs)
	if (locale === "zh-tw") return zh_tw_annual_promo_suffix(inputs)
	if (locale === "ja") return ja_annual_promo_suffix(inputs)
	return en_annual_promo_suffix(inputs)
});